import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			width: '670px',
			display: 'flex',
			flexDirection: 'column',
			alignSelf: 'center',
			paddingBottom: 75,
		},
		loading: {
			color: 'rgba(255, 255, 255, 0.6)',
		},
	})
